import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import toDo from './toDo'
import zeroTrust from './zeroTrust'
import approval from './approval'
import snackbar from './snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    toDo,
    approval,
    snackbar,
    zeroTrust
  },
})
